import fetchRequest from '../fetchRequest';
import inputValidation from '../../../../helpers/inputValidation';
import Cookies from "js-cookie";
import { logAlsImpression, assignModalPageNameAndFire } from '../../../../helpers/osTracking';

class UserInfoComponent {
    /*eslint-disable camelcase*/
    constructor(data, OS_MODAL, emitter) {
        this.personObj = {};
        this.emitter = emitter;

        this.leadSent = Cookies.getJSON(`ElectricLeadSent${data.vin}`);

        this.userInfoContainer = OS_MODAL.querySelector('.user-info');
        this.paymentDetailContainer = OS_MODAL.querySelector('.payment-details');
        this.paymentDetailBodyContainer = OS_MODAL.querySelector('.payment-details__body-container');
        this.paymentDetailNav = OS_MODAL.querySelector('.payment-details__nav');
        this.itemizedPriceContainer = OS_MODAL.querySelector('.itemized-cta');
        this.primaryCtaContainer = OS_MODAL.querySelector('.payment-details__cta-container');
        this.primaryCta = OS_MODAL.querySelector('.cui-button');

        this.firstNameInput = OS_MODAL.querySelector('.input-container__first-name .cui-input');
        this.firstNameError = OS_MODAL.querySelector('.input-container__first-name .input-error');

        this.lastNameInput = OS_MODAL.querySelector('.input-container__last-name .cui-input');
        this.lastNameError = OS_MODAL.querySelector('.input-container__last-name .input-error');

        this.emailInput = OS_MODAL.querySelector('.input-container__email .cui-input');
        this.emailError = OS_MODAL.querySelector('.input-container__email .input-error');

        this.phoneNumberInput = OS_MODAL.querySelector('.input-container__phone-number .cui-input');
        this.phoneNumberError = OS_MODAL.querySelector('.input-container__phone-number .input-error');

        logAlsImpression(0, 2424);
        if (this.leadSent && this.leadSent.first_name) {
            assignModalPageNameAndFire('onlineShopper/paymentDetails');
            this._showPaymentCustomization();
        } else {
            assignModalPageNameAndFire('leads/onlineShopperForm');
            this._showUserInfo();

            this.primaryCta.addEventListener('click', async () => {
                //take in user info
                const fetchParams = Cookies.getJSON(`OnlineShopper${data.vin}`);
                if (fetchParams && this.personObj.first_name && this.personObj.last_name && this.personObj.email) {
                    const dialogContentBody = document.querySelector('[modal-id="online-shopper-modal"] .dialog__content-body');
                    fetchRequest.patchTrackingData(fetchParams, {carsId: data.customerId});
                    this.personObj.preferences = { tcpa_consent: true };
                    let response = await(fetchRequest.patchPerson(fetchParams, this.personObj));
                    if (response) {
                        const expDays = 7;
                        const cookieName = `ElectricLeadSent${data.vin}`;

                        Cookies.set(cookieName, response, { expires: expDays });

                        this._showPaymentCustomization();
                        dialogContentBody.scrollTop = 0;
                        this.emitter.emit("update-person-data", response);
                        assignModalPageNameAndFire('onlineShopper/paymentDetails');
                    }
                } else {
                    this._validateAll();
                }
            });

            this.firstNameInput.addEventListener('blur', () => {
                const valueFN = this.firstNameInput.value;
                if (inputValidation.validateField("first_name", valueFN)) {
                    this.personObj.first_name = valueFN;
                    this.firstNameError.classList.add("hidden");
                    this.firstNameInput.classList.remove("error");
                } else {
                    this.personObj.first_name = "";
                    this.firstNameError.classList.remove("hidden");
                    this.firstNameInput.classList.add("error");
                }
            });

            this.lastNameInput.addEventListener('blur', () => {
                const valueLN = this.lastNameInput.value;
                if (inputValidation.validateField('last_name', valueLN)) {
                    this.personObj.last_name = valueLN;
                    this.lastNameError.classList.add("hidden");
                    this.lastNameInput.classList.remove("error");
                } else {
                    this.personObj.last_name = "";
                    this.lastNameError.classList.remove("hidden");
                    this.lastNameInput.classList.add("error");
                }
            });

            this.emailInput.addEventListener('blur', () => {
                const valueEmail = this.emailInput.value;
                if (inputValidation.validateField('email', valueEmail)) {
                    this.personObj.email = valueEmail;
                    this.emailError.classList.add("hidden");
                    this.emailInput.classList.remove("error");
                } else {
                    this.personObj.email = "";
                    this.emailError.classList.remove("hidden");
                    this.emailInput.classList.add("error");
                }
            });

            this.phoneNumberInput.addEventListener('blur', () => {
                const valuePhone = this.phoneNumberInput.value.replace(/\W/g, '');
                const phoneNumberRaw = valuePhone.replace(/\D/g, '');
                if (phoneNumberRaw.length !== 0) {
                    if (inputValidation.validateField('phone', valuePhone)) {
                        this.personObj.home_phone = valuePhone;
                        this.phoneNumberError.classList.add("hidden");
                        this.phoneNumberInput.classList.remove("error");
                    } else {
                        this.personObj.home_phone = "";
                        this.phoneNumberError.classList.remove("hidden");
                        this.phoneNumberInput.classList.add("error");
                    }
                }
            });

            this.phoneNumberInput.addEventListener("focus", () => {
                const placeHolderStr = "(___) ___-____";
                if (this.phoneNumberInput.value.length === 0 || this.phoneNumberInput.value === placeHolderStr) {
                    this.phoneNumberInput.value = "(___) ___-____";
                    inputValidation.setCaretPosition(this.phoneNumberInput, 1);
                } else {
                    return;
                }
            });
            this.phoneNumberInput.addEventListener("click", (event) => {
                const placeHolderStr = "(___) ___-____";
                if (this.phoneNumberInput.value.length === 0 || this.phoneNumberInput.value === placeHolderStr) {
                    this.phoneNumberInput.value = "(___) ___-____";
                    inputValidation.setCaretPosition(this.phoneNumberInput, 1);
                } else {
                    return;
                }
            });

            /* istanbul ignore next */
            this.phoneNumberInput.addEventListener("keyup", event => inputValidation.formatPhoneNumber(event, this.phoneNumberInput));

            this._autoScrollSetUp();
        }
    }

    _showUserInfo() {
        this.userInfoContainer.classList.remove("hidden");
    }

    _showPaymentCustomization() {
        this.paymentDetailContainer.classList.remove("hidden");
        this.paymentDetailBodyContainer.classList.remove("hidden");
        this.primaryCtaContainer.classList.remove("hidden");
        this.paymentDetailNav.classList.remove("hidden");
        this.itemizedPriceContainer.classList.remove("hidden");
        this.userInfoContainer.classList.add("hidden");
    }

    _autoScrollSetUp() {
        const name_inputs = [
            this.firstNameInput,
            this.lastNameInput
        ];
        let osLeadGateFormNames = document.querySelector('cui-modal[modal-id=online-shopper-modal] .osLeadGateForm--names');
        let osModal = document.querySelector('cui-modal[modal-id=online-shopper-modal] .dialog__content-body');
        if (osLeadGateFormNames && osModal && this.firstNameInput && this.lastNameInput && this.emailInput && this.phoneNumberInput) {
            for (let input of name_inputs) {
                input.addEventListener('focus', () => {
                    input.setSelectionRange(0, 100);
                });
            }
            this.emailInput.addEventListener('focus', () => {
                this.emailInput.setSelectionRange(0, 100);
            });
            this.phoneNumberInput.addEventListener('focus', () => {
                this.phoneNumberInput.setSelectionRange(0, 100);
            });
        }
    }

    _validateAll() {
        // created this way to support IE11, normal construcor is not supported (ie new Event("blur"))
        let blurEvent;
        if (typeof (Event) === "function") {
            blurEvent = new Event("blur");
        } else {
            blurEvent = document.createEvent("Event");
            blurEvent.initEvent("blur", true, true);
        }

        const inputArray = [this.firstNameInput, this.lastNameInput, this.emailInput, this.phoneNumberInput];

        inputArray.map((element) => {
            element.dispatchEvent(blurEvent);
        });
    }
}


export default UserInfoComponent;